// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3X2yc","disabled":"FileBtn_disabled__3YPi6","warn":"FileBtn_warn__LmHbD","fade":"FileBtn_fade__Zeusz"};